import React, { useState, useCallback } from "react";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { Problem } from "../components/landing/Problem";
import { Solution } from "../components/landing/Solution";
import { Features } from "../components/landing/Features";
import { Comparison } from "../components/landing/Comparison";
import { ProductShowcase } from "../components/landing/ProductShowcase";
import { FounderStory } from "../components/landing/FounderStory";
import { MarketValidation } from "../components/landing/MarketValidation";
import { Roadmap } from "../components/landing/Roadmap";
import { WaitlistForm } from "../components/landing/WaitlistForm";
import { Footer } from "../components/landing/Footer";
import { DemoDialog } from "../components/landing/DemoDialog";
import { Toaster } from "../components/ui/sonner";

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);

  const scrollToWaitlist = useCallback(() => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0A0A0A] text-white">
      <Header onJoinClick={scrollToWaitlist} />
      <main>
        <Hero
          onJoinClick={scrollToWaitlist}
          onWatchDemo={() => setDemoOpen(true)}
        />
        <Problem />
        <Solution onJoinClick={scrollToWaitlist} />
        <Features />
        <ProductShowcase />
        <Comparison />
        <FounderStory />
        <MarketValidation />
        <Roadmap />
        <WaitlistForm />
      </main>
      <Footer />

      <DemoDialog
        open={demoOpen}
        onOpenChange={setDemoOpen}
        onJoinClick={scrollToWaitlist}
      />

      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #27272A",
            color: "#fff",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}
